import { IAgency, IAgencyCurrentBalance, IShortAgency } from "agency/model"
import { agencyRPO } from "agency/repository"
import { agencyActionCreator } from "agency/store/actions"
import { IRootState } from "app/model"
import { getStore } from "app/store/store"
import { getUserAgencyId } from "user/tools/common"

export const agencyExist = (agencyId: number | null, state?: IRootState): boolean => {
  if (agencyId === null) {
    return false
  }
  if (typeof agencyId !== "number") {
    throw Error("Missing or invalid parameter agencyId")
  }
  return (state || getStore().getState()).agency.agencies.find(a => a.id === agencyId) !== undefined
}

export const getAgencyById = (agencyId: number | null, state?: IRootState): IAgency => {
  if (typeof agencyId !== "number") {
    throw Error("Missing or invalid parameter agencyId")
  }
  const agency = (state || getStore().getState()).agency.agencies.find(a => a.id === agencyId)
  if (!agency) {
    throw Error(`Agency id="${agencyId}" not found`)
  }
  return agency
}

export function getAgencyNameById(agencyId: number | null): string | undefined {
  if (typeof agencyId !== "number") {
    return ""
  }
  const agency = getStore()
    .getState()
    .agency.agencies.find(a => a.id === agencyId)
  return !agency ? undefined : agency.name
}

export const canUserAddAgencyBudget = (): boolean => {
  const userAgencyId = getUserAgencyId()
  if (typeof userAgencyId !== "number") {
    return false
  }
  const agency = getAgencyById(userAgencyId)
  return agency.stripe_user_id !== null
}

export const setUserAgencyStripeUserIdToTrue = () =>
  getStore().dispatch(agencyActionCreator.setStripeUserId(getUserAgencyId() as number))

export const getAgencyCurrentBalance = async (): Promise<IAgencyCurrentBalance> =>
  await agencyRPO.getAgencyCurrentBalance(getUserAgencyId() as number)

export const getAvailableAgencies = async (): Promise<IShortAgency[]> => agencyRPO.getAvailableAgencies()
